export default __webpack_public_path__ + "static/media/Screenshot_6.983d4b5c.png";